
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import {} from "@newview/ui";
@Component({
  components: {  },
})
export default class PicturePreviewApp extends BaseVue {
  //#region 接口定义区

  //#endregion 接口定义区
  //#region 变量定义区
  @Prop({ default: () => [] })
  imgList; // 图片列表
  @Prop({ default: 0 })
  index; // 首次显示的下标
  @Prop({ default: false })
  isShow; // 是否显示
  @Prop({ default: "" })
  Token; // 文件Token

  currentIndex = 0; // 当前显示图片下标
  show = false; // 是否显示
  //#endregion 变量定义区
  //#region 事件定义区
  mounted() {
    //页面渲染完出发事件
    console.log('PicturePreview')
  }

  @Watch("index")
  changeIndex(value) {
    this.currentIndex = value;
  }

  @Watch("isShow")
  changeShow(value) {
    this.show = value;
    this.currentIndex = this.index
    this.resetImg()
  }
  /**
   * 关闭
   */
  close() {
    this.show = false;
    this.$emit("update:isShow", false);
    this.$emit("close");
  }

  /**
   * 上一张
   */
  prePicture() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.resetImg();
    }
  }

  /**
   * 下一张
   */
  nextPicture() {
    if (this.currentIndex < this.imgList.length - 1) {
      this.currentIndex++;
      this.resetImg();
    }
  }

  // #region 图片变化

  /**
   * 图片复位
   */
  resetImg() {
    this.scaleNum = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

  scaleNum = 1; // 图片缩放比例
  /**
   * 处理滚轮
   */
  handleWheel(event) {
    if (event.wheelDelta > 0) {
      this.scaleImg(0.25);
    } else {
      this.scaleImg(-0.25);
    }
  }
  /**
   * 缩放图片
   */
  scaleImg(value) {
    this.scaleNum += value;
    if (this.scaleNum < 1) {
      this.scaleNum = 1;
    }
  }

  startX = 0; // 鼠标点击位置
  startY = 0;
  translateX = 0; // 图片偏移量
  translateY = 0;
  mousePressed = false; // 鼠标是否按下
  /**
   * 鼠标按下
   */
  handleMouseDown(event) {
    this.mousePressed = true;
    this.startX = event.offsetX;
    this.startY = event.offsetY;
  }

  /**
   * 鼠标移动
   */
  handleMouseMove(event) {
    if (!this.mousePressed) return;
    let disX = event.offsetX - this.startX;
    let disY = event.offsetY - this.startY;
    this.translateX += disX;
    this.translateY += disY;
  }

  // #endregion

  //#endregion 事件定义区
}
